import { UPDATE_DMX_DEVICE_PRESET, UPDATE_DMX_DEVICE_PRESET_SUCCESSFUL, UPDATE_DMX_DEVICE_PRESET_FAILED } from './actionTypes';

export const updateDmxDevicePreset = (preset) => {
  return {
    type: UPDATE_DMX_DEVICE_PRESET,
    payload: { preset },
  };
};

export const updateDmxDevicePresetSuccessful = (message) => {
  return {
    type: UPDATE_DMX_DEVICE_PRESET_SUCCESSFUL,
    payload: message,
  };
};

export const updateDmxDevicePresetFailed = (message) => {
  return {
    type: UPDATE_DMX_DEVICE_PRESET_FAILED,
    payload: message,
  };
};
